import React from "react";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import RenderStatus from "../../../styles/styledStatus";
import { NavLink } from "react-router-dom";

import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledChangeAmount } from "../../../styles/styledChangeAmount";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";

const ReservedBalanceHistoryItem = ({ value, t, notification, setNotification }) => {
  const {
    id,
    processedAmount,
    amount,
    type,
    statusValue,
    createdAt,
    feeForTransferInUSDT,
    currencyName,
    paymentSystemName
  } = value;

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledTableRow
      scroll="auto"
      col="9"
      className="reserved-balance-history__row"
      onClick={(e) => {showDetails(e);}}
      cursor="pointer"
      as={NavLink}
      to={`/payments/${value.id}`}
    >
      <StyledCol data-title="Id">
        <CopyToClipboard
          className="stop-event"
          text={id}
          onCopy={() => {
            setNotification({
              ...notification,
              visible: true,
              type: "success",
              message: t("reservedBalance.table.copied")
            });
          }}
        >
          <StyledBreakWord as="p">
            {id} <StyledCopy
            title={t("reservedBalance.table.copy")}
            className="icon-light-copy"
          />
          </StyledBreakWord>
        </CopyToClipboard>
      </StyledCol>
      <StyledCol data-title={t("reservedBalance.table.paymentSystem")}>
        {paymentSystemName}
      </StyledCol>
      <StyledCol data-title={t("reservedBalance.table.currency")}>
        {currencyName}
      </StyledCol>
      <StyledCol data-title={t("reservedBalance.table.amount")}>
        {amount}
      </StyledCol>
      <StyledCol inline data-title={t("reservedBalance.table.processedAmount")}>
        {processedAmount}
      </StyledCol>
      <StyledCol inline data-title={t("reservedBalance.table.feeForTransferInUSDT")}>
        <StyledChangeAmount
          positive={!feeForTransferInUSDT}
          isZero={Number(feeForTransferInUSDT) === 0}
        >
          {Number(feeForTransferInUSDT) !== 0 && (!feeForTransferInUSDT ? "+" : "-")}
          {feeForTransferInUSDT}
        </StyledChangeAmount>
      </StyledCol>
      <StyledCol inline data-title={t("reservedBalance.table.type")}>
        <RenderStatus status={statusValue} />
      </StyledCol>
      <StyledCol inline data-title={t("reservedBalance.table.type")}>
        {type}
      </StyledCol>
      <StyledCol inline data-title={t("reservedBalance.table.date")}>
        {TimestampToDateMoment(createdAt)}
      </StyledCol>
    </StyledTableRow>
  );
};

export default ReservedBalanceHistoryItem;